var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('myImg',{staticClass:"ad",attrs:{"src":_vm.$beforeUrl(_vm.ad.img)},nativeOn:{"click":function($event){return _vm.$go(_vm.ad.linkUrl)}}})}
var staticRenderFns = []

export { render, staticRenderFns }